export default "__VITE_ASSET__CzAMZn0k__"